import { useBackendData } from 'services/useBackendData';

import { userService } from './userService';

export const usePublicUserData = (userId?: number) => useBackendData(userService.fetchPublicUser, userId);
